import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import sidemenucss from "../../css/sidemenu.module.css";
import commoncss from "../../css/common.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { ReactComponent as BaseCorp } from "../../assets/icons/base-corp.svg";

import { ReactComponent as Plus } from "../../../myfin_v2/assets/icons/plusBlack.svg";

const FSSideMenu = ({
  menuItems,
  subMenu,
  title,
  activeCat,
  setActiveCat,
  setSubMenuId,
  showNotesDetails,
  redirectNote,
  setRedirectNote,
  subMenuId,
}) => {
  const dispatch = useDispatch();

  const routerHistory = useHistory();

  useEffect(() => {
    if (redirectNote && subMenu) {
      setSubMenuId(redirectNote);
      showNotesDetails(redirectNote);
      setRedirectNote(null);
    }
  }, [subMenu]);
  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div
        className={sidemenucss.sidemenuHeader}
        style={{ "min-height": "15vh" }}
      >
        <span className={sidemenucss.sidemenuTitleStd}>{title}</span>
        {/* <span className={sidemenucss.sidemenuSubTitle}>workspace name</span> */}
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} ${commoncss.hideScroll} pt-0`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                className={`${sidemenucss.sidemenuItem} ${
                  activeCat === item.value ? sidemenucss.sidemenuItemActive : ""
                }`}
                onClick={() => {
                  setActiveCat(item.value);
                }}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                  </div>
                </span>
              </li>
              {subMenu &&
                subMenu?.category === item.value &&
                subMenu?.submenu && (
                  <div className={sidemenucss.submenuContainer}>
                    {subMenu.submenu.map((item, idx) => (
                      <div
                        key={idx}
                        className={`${sidemenucss.submenuItem} ${
                          subMenuId === item.value
                            ? sidemenucss.activeSubMenu
                            : null
                        }`}
                        onClick={() => {
                          showNotesDetails(item.value);
                          setSubMenuId(item.value);
                        }}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                )}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FSSideMenu;